import { render, staticRenderFns } from "./MoleculeEditionMapMessages.vue?vue&type=template&id=2ca84c6d&"
import script from "./MoleculeEditionMapMessages.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionMapMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports